export default "__VITE_ASSET__BAKQZQOQ__"